import React from 'react';
import { Header } from '../../../ui/organisms/Header';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { ExperienceSection } from '../components/ExperienceSection';
import { SkillsSection } from '../components/SkillsSection';
import { EducationSection } from '../components/EducationSection';
import { WorkSection } from '../components/WorkSection';
import { ContactSection } from '../components/ContactSection';
import { useResumeData } from '../hooks/useResumeData';
import { useActiveSection } from '../../../hooks/useActiveSection';

const RESUME_PDF_URL = '/resume.pdf';

export function ResumePage() {
  const data = useResumeData();
  const activeSectionId = useActiveSection();

  return (
    <main className="min-h-screen font-sans" role="main">
      <Header
        resumePdfUrl={RESUME_PDF_URL}
        activeSectionId={activeSectionId}
      />
      <HeroSection data={data} resumePdfUrl={RESUME_PDF_URL} />
      {data.about && <AboutSection about={data.about} />}
      <ServicesSection services={data.services} />
      <ExperienceSection items={data.experience} />
      <SkillsSection
        technicalSkills={data.technicalSkills}
        additionalSkills={data.additionalSkills}
      />
      <EducationSection
        education={data.education}
        languages={data.languages}
      />
      <WorkSection workStats={data.workStats} />
      <ContactSection
        contact={data.contact}
        contactAddress={data.contactAddress}
        resumePdfUrl={RESUME_PDF_URL}
      />
      <footer className="border-t border-stone-200 dark:border-stone-700 px-4 py-8 text-center text-sm text-stone-500 dark:text-stone-400">
        © {new Date().getFullYear()} Alex Appadurai · Tech Lead / Mobile Software Engineer
      </footer>
    </main>
  );
}
